/** A real checkbox drawn as a switch, so it keeps the keyboard and the label. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./Switch.css";

export interface SwitchProps {
  readonly label: ReactNode;
  readonly description?: ReactNode;
  readonly checked?: boolean;
  readonly disabled?: boolean;
  readonly name?: string;
  readonly onChange?: (checked: boolean) => void;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function Switch({
  label,
  description,
  checked,
  disabled = false,
  name,
  onChange,
  className,
  style,
}: SwitchProps) {
  return (
    <label className={cn("al-switch", disabled ? "al-switch-disabled" : undefined, className)} style={style}>
      <input
        type="checkbox"
        role="switch"
        className="al-switch-input"
        checked={checked}
        disabled={disabled}
        name={name}
        onChange={(event) => onChange?.(event.target.checked)}
      />
      <span className="al-switch-track" aria-hidden="true">
        <span className="al-switch-knob" />
      </span>
      <span className="al-switch-main">
        <span className="al-switch-label">{label}</span>
        {description !== undefined ? (
          <span className="al-switch-description">{description}</span>
        ) : null}
      </span>
    </label>
  );
}
